export const PRODUCT_IDS = {
	FLEXICARE_RETAIL: '7105b52b-07da-4ccc-abee-3255b78ce33a',
	FLEXICARE_MINI_RETAIL: '8bb596f1-eedc-489a-9b04-6b2381f7b79e',
	FLEXICARE_BUSINESS: 'eed264d7-1124-4fb5-8231-b4f3b976e4ff',
	FLEXICARE_MINI_BUSINESS: 'f18aa7d6-d330-42df-9143-3dc0da762a8a'
}
export const productGuideId = 29
export const nairaSign = <T = string>(val: string | number, isForeign?: boolean) => {
	if (typeof val === 'string' || typeof val === 'number') {
		let amount = val
		// Math.round(val)
		if (!isNaN(amount as number)) {
			amount = Math.round(val as number)
		}

		amount = String(amount)
			.replace(/\D/g, '')
			.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
		return (isForeign ? '$' : '₦' + amount) as T
	}
	return val as T
}
export enum ProductGroupName {
	FLEXICARE_BASTION_BUSINESS = 'flexicare',
	ZENCARE = 'zencare',
	PRIMECARE = 'primecare',
	SENDCARE = 'senior',
	GADGET = 'gadget'
}
export enum HealthAgeLimit {
	HYGEIA = 75,
	BASTION = 70,
	BASTION_SENIOR = 85
}
export const CoverPeriodMap: Record<string, string> = {
	annual: 'anually',
	monthly: 'monthly',
	'bi-anuall': 'bi-annually',
	quarterly: 'quarterly'
}

export const WPBaseUrl = 'https://blog-cms.mycovergenius.com/wp-json/wp/v2'
